var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#003B5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 36.6667C31.768 36.6667 33.4637 35.9643 34.714 34.7141C35.9642 33.4638 36.6666 31.7681 36.6666 30C36.6666 28.2319 35.9642 26.5362 34.714 25.286C33.4637 24.0357 31.768 23.3333 29.9999 23.3333C28.2318 23.3333 26.5361 24.0357 25.2859 25.286C24.0356 26.5362 23.3333 28.2319 23.3333 30C23.3333 31.7681 24.0356 33.4638 25.2859 34.7141C26.5361 35.9643 28.2318 36.6667 29.9999 36.6667Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36.6667V23.3333C15 21.1232 15.878 19.0036 17.4408 17.4408C19.0036 15.878 21.1232 15 23.3333 15H36.6667C38.8768 15 40.9964 15.878 42.5592 17.4408C44.122 19.0036 45 21.1232 45 23.3333V36.6667C45 38.8768 44.122 40.9964 42.5592 42.5592C40.9964 44.122 38.8768 45 36.6667 45H23.3333C21.1232 45 19.0036 44.122 17.4408 42.5592C15.878 40.9964 15 38.8768 15 36.6667Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 20.85L39.1834 20.8317",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b32aac9a1365a3abbbf904f75d8785d9.svg";
export { ForwardRef as ReactComponent };